import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IVideoBlockProps } from "./VideoBlock.props";
export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VideoPlayer
          banner={videoBanner}
          source={videoSource}
          vimeoVideo={vimeoVideo}
          youtubeVideo={youtubeVideo}
        />
      </div>
    </WohaSection>
  );
};
VideoBlock.displayName = "Block::VideoBlock";
